import { action } from 'satcheljs';

/**
 * action to indicate that week start has changed
 */
export const weekStartChanged = action('weekStartChanged');
